import styles from "../../../style/instacheck.module.css";

const ArrowRight = () => (
	<div class={styles.arrowRight}>
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 25.11 41.11"
			height="20px"
			width="12px"
		>
			<g>
				<path
					d="M14.23 20.49C14.15 20.42 5.57 12 1.42 7.83a4.53 4.53 0 1 1 6.35-6.47c4.19 4.17 14.82 14.8 16 15.93a4.51 4.51 0 0 1 0 6.49l-16 16a4.3 4.3 0 0 1-4.57 1.1 4.54 4.54 0 0 1-1.85-7.55c4-4 12.52-12.49 12.88-12.84"
					fill="#fff"
				/>
			</g>
		</svg>
	</div>
);

export default ArrowRight;
